import type { VoidFunctionComponent } from 'react';
import Subnav from '../../generic/Subnav';
import ReportsItem from './ProjectSubnavItemReports';

type Props = {
  isCurrentOrgProject: boolean;
  baseRevisionURL: string;
  baseProjectURL: string;
};

/**
 * ProjectSubnavAuthedItems contains the subnav items which are only
 * visible to logged-in users.
 */
const ProjectSubnavAuthedItems: VoidFunctionComponent<Props> = ({
  isCurrentOrgProject,
  baseRevisionURL,
  baseProjectURL,
}) => {
  if (!isCurrentOrgProject) {
    return null;
  }
  return (
    <>
      <ReportsItem baseRevisionURL={baseRevisionURL} />
      <Subnav.Item to={`${baseProjectURL}/history/builds`} navKey="history/builds">
        Activity
      </Subnav.Item>
      <Subnav.Item to={`${baseProjectURL}/settings`} navKey="settings">
        Settings
      </Subnav.Item>
    </>
  );
};

export default ProjectSubnavAuthedItems;
